import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { FormFieldDefinition, FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { WidgetConfiguration, WidgetConfigurationsService } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { getDefaultWidgetConfigAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { mapWherePropertiesMatch } from '@common/index';
import { CreditorDetailsService } from './creditor-details.service';
import { SaveDetailsWidgetConfigurationRequest } from '@common/models/save-creditor-details-widget-configuration-request';

@Injectable({
  providedIn: 'root'
})
export class CreditorDetailsWidgetAdminHandler implements WidgetAdminHandler {

  constructor(
    private readonly widgetConfigService: WidgetConfigurationsService,
    private readonly detailsService: CreditorDetailsService) {
  }

  private createSaveRequest(selectedConfig: WidgetConfiguration, adminFormValue: any): SaveDetailsWidgetConfigurationRequest {

    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);
    const saveRequest = {} as SaveDetailsWidgetConfigurationRequest;

    saveRequest.WidgetConfiguration = copyOfSelectedConfig;
    saveRequest.DetailsWidgetConfigurationModel = {
      WidgetConfigurationId: selectedConfig.id,
      SelectedFields: adminFormValue.selectedFields
    };

    return saveRequest;
  }

  initialise(): boolean {
    return true;
  }

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition | Observable<FormDefinition> {
    return this.detailsService.getFields(selectedConfig.id).pipe(
      map(fields => {
        const formDefinition = getDefaultWidgetConfigAdminForm(selectedConfig);
        formDefinition.fields.push(
          {
            key: 'selectedFields',
            label: 'Displayed Information',
            value: fields.filter(x => x.Selected),
            type: 'multiSelect',
            dataKey: 'DisplayName',
            optionLabel: 'DisplayName',
            options: fields,
            validation: [],
            asyncValidation: [],
          } as FormFieldDefinition
        );
        return formDefinition;
      })
    );
  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue): Observable<boolean> {
    const saveRequest = this.createSaveRequest(selectedConfig, adminFormValue);
    return this.detailsService.createCopyOfConfiguration(saveRequest);
  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
   const saveRequest = this.createSaveRequest(selectedConfig, adminFormValue);
   return this.detailsService.saveConfiguration(saveRequest);
  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);
    return this.widgetConfigService.delete(copyOfSelectedConfig).pipe(map(() => true));
  }
}
